@if (fileSelectOptions$ | async; as fileSelectOptions) {
  <div
    class="drop-container {{ displaySize }}"
    [ngClass]="{ 'is-drop-over': dragOver }">
    <div
      ngFileDrop
      [options]="fileSelectOptions"
      (uploadOutput)="onUploadOutput($event)"
      [uploadInput]="uploadInput">
      <label
        for="fileInput"
        class="drop-container__input-field">
        <div class="container-text select-file">
          @if (state === UploaderState.selectFile) {
            <div class="drop-container__title">{{ title }}</div>
            <p
              class="drop-container__text"
              [ngbTooltip]="fileRequirements">
              {{ text }}
              @if (destinationInfo) {
                <i class="ms-1 iconoir-info-circle"> </i>
              }
            </p>
            @if (textExtra) {
              <p class="drop-container__text">
                {{ textExtra }}
              </p>
            }
            <ng-template #fileRequirements>
              <bo-file-requirements [destinationInfo]="destinationInfo"></bo-file-requirements>
            </ng-template>
          }
          <input
            ngFileSelect
            #fileInput
            id="fileInput"
            type="file"
            class="drop-container__input-field"
            [options]="fileSelectOptions"
            (uploadOutput)="onUploadOutput($event)"
            [uploadInput]="uploadInput" />
        </div>
        @if (state === UploaderState.selectFile) {
          <div class="text-center">
            <div class="btn btn-light-on-white">Choose a file</div>
          </div>
        }
      </label>
      @if (state === UploaderState.uploading) {
        <div class="container-text mt-neg-4">
          <div class="drop-container__title">Uploading...</div>
          @for (f of files; track f) {
            <div>
              @if (f.progress.data) {
                <ngb-progressbar
                  class="mb-2"
                  type="secondary"
                  [animated]="true"
                  [value]="f.progress.data!.percentage" />
              }
              <p class="small mb-0">{{ f.name }}</p>
            </div>
          }
        </div>
      }
    </div>
  </div>
} @else {
  <div class="drop-container">
    <app-loader spacingClass="p-2"></app-loader>
  </div>
}

@if (error) {
  <alert
    [dismissible]="false"
    type="danger">
    {{ error }}
  </alert>
}
